module.exports = "/shared/img/menu-active-background.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/menu-active-background.png
// module id = 443
// module chunks = 13